let config = {
    host:"classroom.ayskill.com",
    serverUrl:"https://classroom.ayskill.com/bigbluebutton/",
    secret:"pBXIfVjQURBbI43pb33ElOr4sjPqhzuazVgC7KjHg",
    app:"/bigbluebutton/api/",
}
export default config;